module.exports = __webpack_public_path__ + "img/LEP_03.0de444ce.png";